export default __webpack_public_path__ + "static/media/rules.6bb8a7f2.svg";